module.exports = __webpack_public_path__ + "img/Harpy_Feather_Duster.d0691404.png";